import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// A regisztrációs oldal fejléce: ugyanaz a panel és elrendezés, mint a rendezvénylistán.
// Balra, függőlegesen középen a visszalépés a rendezvények listájára (a Kilépés gombbal azonos formájú gomb),
// középen a "Regisztráció" cím és alatta kisebb betűvel a rendezvény neve, jobbra a név, az e-mail-cím és a Kilépés.
export default function RegisztracioFejlec({ felhasznalo, rendezveny, onKilepes }) {
    return (
        <div className="felhasznaloAdatFejlec regisztracioFejlec">
            <div className="fejlecSor">
                <div className="fejlecBal">
                    <Link to="/rendezvenyek" className="btn btn-outline-secondary visszaGomb">
                        <FontAwesomeIcon icon="fa-arrow-left" /> Rendezvények
                    </Link>
                </div>
                <div className="fejlecKozep mindig">
                    <div className="oldalCim">Regisztráció</div>
                    {rendezveny ?
                        <div className="rendezvenyCim">{rendezveny.Cim}{rendezveny.Kezdes ? <><br />{rendezveny.Kezdes}</> : undefined}</div>
                        : undefined
                    }
                </div>
                <div className="fejlecFelhasznalo">
                    {felhasznalo.Nev !== '' ? <div className="nev">{felhasznalo.Nev}</div> : undefined}
                    <div className="email">{felhasznalo.Email}</div>
                    <Button variant="outline-secondary" className="kilepesGomb" onClick={onKilepes}>Kilépés</Button>
                </div>
            </div>
        </div>
    );
}
